import { Menu, MenuItem } from '@mui/material';
import { IRouteMetadata } from './types/auth-response.model';
import { RouteLink } from 'src/components/analytics/index';
import './app-drawer.scss';

export default function SideMenuBar({
  openModal,
  menuParent,
  menus,
  anchorEl,
  handleClose,
  itemIndex,
  getActiveItem
}: Readonly<{
  openModal: boolean;
  menuParent: string;
  menus: IRouteMetadata[];
  anchorEl: any;
  handleClose: () => void;
  itemIndex: number;
  getActiveItem: any;
}>) {
  /**
   * handler for click event on menu item
   */
  const getParentIndex = () => {
    getActiveItem(itemIndex);
  };

  return (
    <Menu
      hideBackdrop
      style={{ left: '35px', display: openModal ? 'block' : 'none' }}
      id='simple-menu'
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleClose}
      MenuListProps={{ onMouseLeave: handleClose }}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <div className='menu-title-div'>{menuParent}</div>
      {menus
        .filter((menu) => menu.parent.is_visible)
        .map((menuData) => {
          if (menuData.children.length > 1) {
            return (
              <div key={menuData.parent.name}>
                <MenuItem className='mat-submenu-title'>
                  <div>{menuData.parent.alias}</div>
                </MenuItem>
                {menuData.children
                  .filter((data) => data.parent.is_visible)
                  .map((menu) => (
                    <MenuItem
                      key={menu.parent.name}
                      onClick={handleClose}
                      className='submenu-item'
                    >
                      <RouteLink
                        link={menu.parent.route_url}
                        description={menu.parent.alias}
                        handleClick={getParentIndex}
                      />
                    </MenuItem>
                  ))}
              </div>
            );
          }
          return (
            <MenuItem
              key={menuData.parent.name}
              onClick={handleClose}
              className='submenu-item'
            >
              <RouteLink
                link={menuData.parent.route_url}
                description={menuData.parent.alias}
                handleClick={getParentIndex}
              />
            </MenuItem>
          );
        })}
    </Menu>
  );
}
